import { Price as OccPrice } from '@spartacus/core';
import { Unit } from './unit.model';

export interface CustomOccPrice extends OccPrice {
  multiplicity?: number;
  orderMinimum?: number;
}

export enum PriceKind {
  REGULAR = 'regular',
  PERSONAL = 'personal',
  TRANSIT = 'transit',
  CROSSED = 'crossed',
}

declare function convertFn(): Unit;
declare function convertFn(amount: number): Unit & { amount: number };

export type ConvertFn = typeof convertFn;

export interface Price extends CustomOccPrice {
  kind: PriceKind;
  unit?: Unit;
  saleUnit: Unit;
}

export interface SelectedPrice extends Price {
  kind: PriceKind.REGULAR | PriceKind.TRANSIT;
  minValue?: number;
}
